import { render } from "./sms-compliance-keywords.vue?vue&type=template&id=f4de05e8&scoped=true"
import script from "./sms-compliance-keywords.vue?vue&type=script&lang=js"
export * from "./sms-compliance-keywords.vue?vue&type=script&lang=js"

import "./sms-compliance-keywords.vue?vue&type=style&index=0&id=f4de05e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4de05e8"]])

export default __exports__